import { z } from "zod";

const envSchema = z.object({
	VITE_API_URL: z.string().url().default("http://localhost:3000"),
	VITE_POLYGONSCAN_BASE: z.string().url().default("https://polygonscan.com"),
});

export const env = envSchema.parse({
	VITE_API_URL: import.meta.env.VITE_API_URL,
	VITE_POLYGONSCAN_BASE: import.meta.env.VITE_POLYGONSCAN_BASE,
});
